export class IndexedDBService {

    constructor(dbName = "MyAppDB", storeName = "appState", version = 1) {
      this.dbName = dbName;
      this.storeName = storeName;
      this.version = version;
      this.db = null;
    }
  
    async init() {
      if (this.db) return this.db;
  
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(this.dbName, this.version);
  
        request.onerror = () => reject("Error opening DB");
  
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains(this.storeName)) {
            db.createObjectStore(this.storeName, { keyPath: "key" });
          }
        };
  
        request.onsuccess = (event) => {
          this.db = event.target.result;
          resolve(this.db);
        };
      });
    }
  
    async save(key, value) {
      const db = await this.init();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.storeName, "readwrite");
        const store = tx.objectStore(this.storeName);
        store.put({ key, value });
  
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => reject("Failed to save data");
      });
    }
  
    async get(key) {
      const db = await this.init();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.storeName, "readonly");
        const store = tx.objectStore(this.storeName);
        const request = store.get(key);
  
        request.onsuccess = () => resolve(request.result?.value);
        request.onerror = () => reject("Failed to get data");
      });
    }
  
    async delete(key) {
      const db = await this.init();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.storeName, "readwrite");
        const store = tx.objectStore(this.storeName);
        store.delete(key);
  
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => reject("Failed to delete data");
      });
    }
  
    async clear() {
      const db = await this.init();
      return new Promise((resolve, reject) => {
        const tx = db.transaction(this.storeName, "readwrite");
        const store = tx.objectStore(this.storeName);
        store.clear();
  
        tx.oncomplete = () => resolve(true);
        tx.onerror = () => reject("Failed to clear store");
      });
    }
  }
  